var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.75H4.75V21.25H5C5.41421 21.25 5.75 21.5858 5.75 22C5.75 22.4142 5.41421 22.75 5 22.75H3C2.58579 22.75 2.25 22.4142 2.25 22C2.25 21.5858 2.58579 21.25 3 21.25H3.25V7.75H3C2.58579 7.75 2.25 7.41421 2.25 7C2.25 6.58579 2.58579 6.25 3 6.25H5C5.41421 6.25 5.75 6.58579 5.75 7C5.75 7.41421 5.41421 7.75 5 7.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3 4.95001V4.70001L7.79999 4.70001V4.95001C7.79999 5.36422 7.46419 5.70001 7.04999 5.70001C6.63579 5.70001 6.29999 5.36422 6.29999 4.95001L6.29999 2.95001C6.29999 2.5358 6.63579 2.20001 7.04999 2.20001C7.46419 2.20001 7.79999 2.5358 7.79999 2.95001V3.20001L21.3 3.20001V2.95001C21.3 2.5358 21.6358 2.20001 22.05 2.20001C22.4642 2.20001 22.8 2.5358 22.8 2.95001V4.95001C22.8 5.36422 22.4642 5.70001 22.05 5.70001C21.6358 5.70001 21.3 5.36422 21.3 4.95001Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7C7.89543 7 7 7.89543 7 9V20C7 21.1046 7.89543 22 9 22H20C21.1046 22 22 21.1046 22 20V9C22 7.89543 21.1046 7 20 7H9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSize);
export default __webpack_public_path__ + "static/media/size.51fa06d44ce5754e12c1f0c758cf57d5.svg";
export { ForwardRef as ReactComponent };